import classNames from "classnames";
import React, { useContext, useState, useRef, useEffect } from "react";
import { ChatContext } from "../../../context/chat/ChatContext";
import { SocketContext } from "../../../context/SocketContext";
import {
  ChatState,
  formatLastMessageTime,
  MessageStatus,
  NetworkIcon,
  TypeMsg,
} from "../../../components/chat/ChatComponents";
import { Dropdown, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { CSS } from "@dnd-kit/utilities";
import { fetchWithToken } from "../../../api/fetch";
import { types } from "../../../types/types";
import toastConfig from "../../../utils/toastConfig";
import ModalAssign from "../../../components/modals/ModalAssign";
import { useSortable } from "@dnd-kit/sortable";
import { AuthContext } from "../../../context/AuthContext";
const baseURL = process.env.REACT_APP_API;

const ItemUs = ({ user, id, openChat }) => {
  const { chatState, dispatch } = useContext(ChatContext);
  const { auth } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);
  const { activeChat, chatsLists } = chatState;
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: `${id}-${user.id_user}` });
  const info = {
    type: "etiqueta",
    id_user: selectedUserId,
  };
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ?? "transform 200ms ease", // transición suave si no hay una
    backgroundColor: isDragging ? "#e0f7fa" : "#fff",
    // padding: "12px 16px",
    marginBottom: "10px",
    // fontSize: "22px",
    borderRadius: "8px",
    // border: isDragging ? "2px dashed #00acc1" : "1px solid #ddd",
    cursor: isDragging ? "grabbing" : "grab",
    opacity: isDragging ? 0.9 : 1,
    boxShadow: isDragging
      ? "0 8px 16px rgba(0, 172, 193, 0.3)"
      : "0 2px 6px rgba(0, 0, 0, 0.05)",
    transformOrigin: "center center",
    scale: isDragging ? 1.03 : 1,
  };

  useEffect(() => {
    // Actualizar la lista de chats cuando se recibe un nuevo mensaje
    const handleNewMessage = (newUser) => {
      dispatch({ type: types.newMessageOnChat, payload: newUser });
    };

    // Actualizar la etiqueta de un chat
    const handleTagChange = (data) => {
      dispatch({ type: types.tagChange, payload: data });
    };

    // Actualizar la lista de chats
    const handleChatList = (data) => {
      dispatch({ type: types.refreshChatList, payload: data });
    };
    const handleChatListRemove = (data) => {
      dispatch({ type: types.removeChatUser, payload: data });
    };

    socket?.on("new-sms", handleNewMessage);
    socket?.on("mark-us", handleTagChange);
    socket?.on("updChatList", handleChatList);
    socket?.on("removeChatList", handleChatListRemove);

    return () => {
      socket?.off("new-sms", handleNewMessage);
      socket?.off("mark-us", handleTagChange);

      socket?.off("updChatList", handleChatList);
      socket?.off("removeChatList", handleChatListRemove);
    };
  }, [dispatch, socket, activeChat]);

  // Actualizar el estado de los mensajes
  useEffect(() => {
    const handleNewMessage = (newUser) => {
      dispatch({
        type: types.refreshChatList,
        payload: newUser,
      });
    };

    socket?.on("us-item", handleNewMessage);

    return () => socket?.off("us-item", handleNewMessage);
  }, [socket, dispatch, activeChat, chatsLists]);
  return (
    <>
      <div
        className={classNames(
          "cursor-pointer d-flex border-bottom px-2 py-1 o"
        )}
        onClick={async () => {
          if (user.smsunread > 0) socket?.emit("leidos", user.id);
          openChat(user);
          dispatch({
            type: types.selectChat,
            payload: user,
          });
          openChat(user);
        }}
        ref={setNodeRef}
        style={style}
      >
        <div
          className="me-2 d-flex align-items-center"
          style={{ cursor: "grab" }}
          {...listeners} // <- aquí aplica listeners solo al icono
        >
          <i className="mdi mdi-arrow-all fs-4 text-muted" />
        </div>

        <div
          style={{
            minWidth: "calc(100% - 55px)",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center"></div>
            <h5 className="d-inline-block font-13 my-0 ms-1 text-black ">
              <img
                src={
                  user.foto.includes("http")
                    ? `${user.foto}`
                    : `${baseURL}/${user.foto}`
                }
                className="me-1 rounded-circle border"
                height="38"
                alt="Foto de perfil"
                style={{
                  minWidth: "28px",
                }}
              />
              <ChatState user={user} />

              <NetworkIcon network={user?.red} />
            </h5>
            <span
              className="fw-bold "
              style={{ fontSize: "14px", width: "900px" }}
            >
              {" "}
              {`${user.first_name ?? ""} ${user.last_name ?? ""}`}
            </span>
            <span
              className="text-info d-inline-block"
              style={{
                maxWidth: "170px", // o el tamaño que necesites
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                marginLeft: "5px",
                marginBottom: "0px",
              }}
              title={user.customer} // para mostrar el texto completo al pasar el mouse
            >
              {user.customer}
            </span>{" "}
            <div className="d-flex align-items-center float-end ">
              <span className="text-secondary-lighten font-11 me-1">
                {formatLastMessageTime(user.date)}
              </span>

              <Dropdown
                className="conversation-actions"
                onClick={(e) => e.stopPropagation()}
              >
                <Dropdown.Toggle
                  variant="link"
                  className="btn btn-sm btn-link arrow-none shadow-none p-0"
                >
                  <i className="uil uil-ellipsis-v text-secondary" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {user.idmark > 0 ? (
                    <Dropdown.Item
                      className="text-danger fw-bold conversation-action"
                      onClick={async () => {
                        const resp = await fetchWithToken(
                          "etiquetas/unassign-mark",
                          { id_us: user.id_user },
                          "PUT"
                        );
                        // Muestra mensaje de éxito o error
                        if (resp.ok) {
                          toast.success(resp.msg, toastConfig);
                          socket.emit("addMark", {
                            id_us: user.id_user,
                          });
                        } else {
                          toast.error(resp.msg, toastConfig);
                        }
                      }}
                    >
                      Quitar etiqueta
                    </Dropdown.Item>
                  ) : null}

                  <Dropdown.Item
                    onClick={() => {
                      setSelectedUserId(user.id_user);
                      setShowModal(true);
                    }}
                    className="conversation-action"
                  >
                    Asignar etiqueta
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      socket?.emit("unread", user.id_user);
                    }}
                  >
                    Marcar como no leído
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      socket.emit("asignar", {
                        agente: "",
                        type: "cerrado",
                        auth: auth.uid,
                        id: user.id_user,
                      });
                    }}
                  >
                    Cerrar chat
                  </Dropdown.Item>

                  {user.idcus && (
                    <Dropdown.Item
                      onClick={() => {
                        socket?.emit("desasociar", user.id_user);
                        dispatch({
                          type: types.closeChat,
                          payload: user.id_user,
                        });
                      }}
                    >
                      Cancelar vínculo con cliente
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center text-secondary-lighten mt-2">
            <span
              className="font-14 me-3"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={user.object}
            >
              {user.status === "send" && (
                <span className="text-secondary font-14 fw-bold me-1">Tú:</span>
              )}
              <TypeMsg chatItem={user} />
            </span>

            <div className="d-flex align-items-center gap-1 font-16">
              {user.smsunread > 0 ? (
                <span
                  className="bg-success rounded-circle text-white fw-bold font-12 px-1"
                  title="No leído"
                >
                  <span>{user.smsunread}</span>
                </span>
              ) : user.status === "send" ? (
                <MessageStatus status={user.statesms} />
              ) : null}
              {user.mark && (
                <span
                  className="badge font-10 text-white"
                  style={{ backgroundColor: user.color_mk }}
                  title={user.mark}
                >
                  <i className="mdi mdi-bookmark font-12" />
                </span>
              )}
              {user.pago ? (
                <span
                  className="badge font-10 text-white bg-warning mx-1"
                  title={"PAGO"}
                >
                  <i className="mdi mdi-cash font-12" />
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {showModal ? (
        <ModalAssign
          show={showModal}
          handleClose={() => {
            setShowModal(false);
            setSelectedUserId(null);
          }}
          info={info}
        />
      ) : null}
    </>
  );
};

export default ItemUs;
